export enum AUTH_TYPE {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}
